import { render, staticRenderFns } from "./NotificationFixed.vue?vue&type=template&id=494d8560"
import script from "./NotificationFixed.vue?vue&type=script&lang=js"
export * from "./NotificationFixed.vue?vue&type=script&lang=js"
import style0 from "./NotificationFixed.vue?vue&type=style&index=0&id=494d8560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports